import { useState } from "react";
import {
  Layout,
  Menu,
  Row,
  Col,
  Dropdown,
  Button,
  Space,
  Popconfirm,
  Image,
} from "antd";
import "antd/dist/reset.css";
import {
  UserOutlined,
  FileDoneOutlined,
  FunctionOutlined,
  SettingOutlined,
  ProfileOutlined,
  ScheduleOutlined,
  AuditOutlined,
  LogoutOutlined,
  EyeOutlined,
  LikeOutlined,
  FolderAddOutlined,
  UploadOutlined,
  FileOutlined,
  ControlOutlined,
  ProjectOutlined,
  HeartOutlined
} from "@ant-design/icons";

import AppRouter from "./Routes";
import { Link, NavLink } from "react-router-dom";
import {
  logout,
  getProfile,
  isAuthorizedRole,
  isAuthenticated,
  RenderAnonymous,
  RenderAuthenticated,
} from "@seims/shared/src/security";
import { TimerControl } from '../components/custom/TimerControl';
import { handleLogin } from "../security/ToggleViews";

const { Header, Content, Footer, Sider } = Layout;

export const CustomLayout = () => {
  const [currentYear, setCurrentYear] = useState(new Date().getFullYear());
  const [collapsed, setCollapsed] = useState(false);
  const [userData, setUserData] = useState({ ...getProfile() }); //getProfile());

  // const username = userData.firstName;

  const onCollapse = (collapse) => {
    setCollapsed(collapse);
  };

  const handleMenuClick = () => { };

  const getMenuItems = () => {
    return [
      // isAuthorizedRole(["ADMIN", "CORE", "DSI_OFFICIAL", "SAASTA_OFFICIAL", "HSRC_OFFICIAL"]) && (
      //   getItem(<NavLink to="/worklist"> Worklist </NavLink>, 'worklist',
      //     <FileDoneOutlined style={{
      //       fontSize: "25px",
      //       color: "#FFF",
      //       marginLeft: "0px",
      //     }} />,
      //     null, ''
      //   )
      // ),
      isAuthorizedRole(["ADMIN"]) &&
      getItem(
        <Link
          to="/config"
          style={{
            fontSize: "16px",
            color: "#FFF",
            marginLeft: "0px",
            // paddingTop: "5px",
            // paddingBottom: "5px",
          }}
        >
          {" "}
          Administration{" "}
        </Link>,
        "administration",
        <SettingOutlined
          style={{
            fontSize: "25px",
            color: "#FFF",
            marginLeft: "0px",
          }}
        />,
        [getItem(
          <NavLink to="/system/addresscorrection"> Addresses Correction </NavLink>,
          "addresscorrection",
          <FileDoneOutlined style={{
            fontSize: "25px",
            color: "#000",
            marginLeft: "0px",
          }} />
          ,
          null,
          ""
        ),
        getItem(
          <NavLink to="/document-repository/configuration"> Document Repository Configuration</NavLink>,
          "lookupconfig",
          <ControlOutlined
            style={{
              fontSize: "25px",
              color: "#000",
              marginLeft: "0px",
            }}
          />,
          null,
          ""
        ),
        getItem(
          <NavLink to="/errorlogs"> Error Logs </NavLink>,
          "errorlogs",
          <ProfileOutlined
            style={{
              fontSize: "25px",
              color: "#000",
              marginLeft: "0px",
            }}
          />,
          null,
          ""
        ),
        getItem(
          <NavLink to="/faq"> Manage FAQ </NavLink>,
          "faq",
          <ProfileOutlined
            style={{
              fontSize: "25px",
              color: "#000",
              marginLeft: "0px",
            }}
          />,
          null,
          ""
        ),
        getItem(
          <NavLink to="/nysprogramme"> Manage NYS Programme </NavLink>,
          "nys",
          <ProfileOutlined
            style={{
              fontSize: "25px",
              color: "#000",
              marginLeft: "0px",
            }}
          />,
          null,
          ""
        ),
        getItem(
          <NavLink to="/finyear"> Manage Financial Year</NavLink>,
          "finyear",
          <ProfileOutlined
            style={{
              fontSize: "25px",
              color: "#000",
              marginLeft: "0px",
            }}
          />,
          null,
          ""
        ),
        getItem(
          <NavLink to="/usermanagement"> Manage Users </NavLink>,
          "manageusers",
          <ProfileOutlined
            style={{
              fontSize: "25px",
              color: "#000",
              marginLeft: "0px",
            }}
          />,
          null,
          ""
        ),
        getItem(
          <NavLink to="/stemi/olympiad/names"> Manage STEMI Olympiad Name </NavLink>,
          "stemi-oly-names",
          <ProfileOutlined
            style={{
              fontSize: "25px",
              color: "#000",
              marginLeft: "0px",
            }}
          />,
          null,
          ""
        ),
        getItem(
          <NavLink to="/system/configurations"> System Configuration</NavLink>,
          "systemconfig",
          <ProfileOutlined
            style={{
              fontSize: "25px",
              color: "#000",
              marginLeft: "0px",
            }}
          />,
          null,
          ""
        ),
        getItem(
          <NavLink to="/system/user-guide"> User Guide</NavLink>,
          "user-guide",
          <ProfileOutlined
            style={{
              fontSize: "25px",
              color: "#000",
              marginLeft: "0px",
            }}
          />,
          null,
          ""
        ),

        ],
        null,
        "Group"
      ),

      isAuthenticated() &&
      getItem(
        <Link
          to="/document-repository/view"
          style={{
            fontSize: "16px",
            color: "#FFF",
            paddingTop: "5px",
            paddingBottom: "5px",
          }}
          data-testid="document-repository-link"  
        >
          Document Repository </Link>,
        "document",
        <FolderAddOutlined
          style={{
            fontSize: "25px",
            color: "#FFF",
            marginLeft: "0px",
          }}
        />,
        isAuthorizedRole(["ADMIN", "DOCUMENT_REPO_RATIFIER", "DOCUMENT_REPO_UPLOADER"]) &&
        [
          getItem(
            <NavLink to="/document-repository/manage">Manage Documents</NavLink>,
            "documentupload",
            <UploadOutlined
              style={{
                fontSize: "25px",
                color: "#000",
                marginLeft: "0px",
              }}
            />,
            null,
            ""
          ),
          getItem(
            <NavLink to="/document-repository/view">View Documents</NavLink>,
            "documentview",
            <FileOutlined
              style={{
                fontSize: "25px",
                color: "#000",
                marginLeft: "0px",
              }}
            />,
            null,
            ""
          ),
        ],
        null,
        "Group"
      ),
      isAuthorizedRole(["ADMIN", "EVENTS_RATIFIER", "PROGRAMME_LEAD"]) &&
      getItem(
        <NavLink to="/events-management"> Events </NavLink>,
        "Events",
        <ScheduleOutlined
          style={{
            fontSize: "25px",
            color: "#FFF",
            marginLeft: "0px",
          }}
        />,
        null,
        ""
      ),
      isAuthorizedRole([
        "ADMIN",
        "CORE",
        "DSI_OFFICIAL",
        "SAASTA_OFFICIAL",
        "HSRC_OFFICIAL",
      ]) &&
      getItem(
        <NavLink to="/candidate"> NYS </NavLink>,
        "NYS",
        <ProfileOutlined
          style={{
            fontSize: "25px",
            color: "#FFF",
            marginLeft: "0px",
          }}
        />,
        null,
        ""
      ),
      isAuthorizedRole(["ADMIN", "EVENTS_RATIFIER", "PROGRAMME_LEAD"]) &&
      getItem(
        <NavLink to="/partnership"> Partnerships </NavLink>,
        "partnership",
        <LikeOutlined
          style={{
            fontSize: "25px",
            color: "#FFF",
            marginLeft: "0px",
          }}
        />,
        null,
        ""
      ),
      isAuthorizedRole(["ADMIN", "SAASTA_OFFICIAL", "DSI_OFFICIAL"]) &&
      getItem(
        <Link
          to="/project-management"
          style={{
            fontSize: "16px",
            color: "#FFF",
            paddingTop: "5px",
            paddingBottom: "5px",
          }}
        >
          Citizen Science </Link>,
        "citizenscience",
        <ProjectOutlined
          style={{
            fontSize: "25px",
            color: "#FFF",
            marginLeft: "0px",
          }}
        />,
        null,
        "Group"
      ),
      isAuthorizedRole([
        "ADMIN", "EVENTS_RATIFIER", "PROGRAMME_LEAD", "EVENTS_LEAD", "VOL_SCI_LEAD"
      ]) &&
      getItem(
        <NavLink to="/volunteer-scientist"> Volunteer Scientists/STEM Professionals </NavLink>,
        "VOLSCI",
        <HeartOutlined
          style={{
            fontSize: "25px",
            color: "#FFF",
            marginLeft: "0px",
          }}
        />,
        null,
        ""
      ),
      isAuthorizedRole(["ADMIN", "STEMI_OFFICIAL", "STEMI_LEAD_AGENT"]) &&
      getItem(
        <Link
          to="/uploadhistory"
          style={{
            fontSize: "16px",
            color: "#FFF",
            paddingTop: "5px",
            paddingBottom: "5px",
          }}
        >
          {" "}
          STEMI Olympiad{" "}
        </Link>,
        "STEMIOlympiad",
        <FunctionOutlined
          style={{
            fontSize: "25px",
            color: "#FFF",
            marginLeft: "0px",
          }}
        />,
        [
          isAuthorizedRole(["STEMI_OFFICIAL", "STEMI_LEAD_AGENT"]) &&
          getItem(
            <NavLink to="/stemi"> Data Upload </NavLink>,
            "STEMI-Data-Upload",
            <ProfileOutlined
              style={{
                fontSize: "25px",
                color: "#000",
                marginLeft: "0px",
              }}
            />,
            null,
            ""
          ),
          getItem(
            <NavLink to="/uploadhistory"> Upload History </NavLink>,
            "STEMI-Upload-History",
            <ProfileOutlined
              style={{
                fontSize: "25px",
                color: "#000",
                marginLeft: "0px",
              }}
            />,
            null,
            ""
          ),

          // getItem(
          //   <NavLink to="/agentuploadhistory"> Agent Upload History </NavLink>,
          //   "Agent-Upload-History",
          //   <ProfileOutlined
          //     style={{
          //       fontSize: "25px",
          //       color: "#000",
          //       marginLeft: "0px",
          //     }}
          //   />,
          //   null,
          //   ""
          // ),
        ],
        null,
        "Group"
      ),
        isAuthorizedRole([
        "ADMIN",
        "NYS_DATA_UPLOADER",
        "PROGRAMME_LEAD",
        "EVENTS_DATA_UPLOADER",
      ]) &&
      getItem(
        <Link
          to={'/upload-history'}
          style={{
            fontSize: "16px",
            color: "#FFF",
            paddingTop: "5px",
            paddingBottom: "5px",
          }}
        >
          {" "}
          Data Migration {" "}
        </Link>,
        "DataMigration",
        <UploadOutlined
          style={{
            fontSize: "25px",
            color: "#FFF",
            marginLeft: "0px",
          }}
        />,
        [
          isAuthorizedRole(["NYS_DATA_UPLOADER", "EVENTS_DATA_UPLOADER"]) &&
          getItem(
            <NavLink to="/data-upload"> Data Upload </NavLink>,
            "Data-Migration",
            <ProfileOutlined
              style={{
                fontSize: "25px",
                color: "#000",
                marginLeft: "0px",
              }}
            />,
            null,
            ""
          ),
          getItem(
            <NavLink to="/upload-history"> Upload History </NavLink>,
            "Upload-History",
            <ProfileOutlined
              style={{
                fontSize: "25px",
                color: "#000",
                marginLeft: "0px",
              }}
            />,
            null,
            ""
          ),
        ],
        null,
        "Group"
      ),
      isAuthenticated() &&
      getItem(
        <NavLink
          to="/nysreports"
          style={{
            fontSize: "16px",
            color: "#FFF",
            paddingTop: "5px",
            paddingBottom: "5px",
          }}
        >
          {" "}
          Reports{" "}
        </NavLink>,
        "REPORTS",
        <AuditOutlined
          style={{
            fontSize: "25px",
            color: "#FFF",
            marginLeft: "0px",
          }}
        />,

        [
          getItem(
            <NavLink to="/citizen-science">Citizen Science </NavLink>,
            "CitizenScienceReport",
            null,
            ""
          ),
          getItem("Event", "sub1", null,
            [
              getItem(
                <NavLink to="/event/group-report">Event Groups</NavLink>,
                "EventByGroupReport",
                null,
                ""
              ),
              getItem(
                <NavLink to="/event/individual-report">Individual Events</NavLink>,
                "IndividualEventReport",
                null,
                ""
              ),
              getItem(
                <NavLink to="/event/venue-type-report" style={{
                  marginLeft: "0px",
                }}>Venue Types</NavLink>,
                "EventsReport",
                null,
                ""
              ),
              getItem(
                <NavLink to="/event/location-report">Events Geographic Location</NavLink>,
                "EventsLocationReport",
                null,
                ""
              ),
            ]),
          getItem(
            <NavLink to="/nysreports">National Youth Service</NavLink>,
            "NYSReports",
            null,
            ""
          ),
          getItem(
            <NavLink to="/partnershipreports">Partnership </NavLink>,
            "PartnershipReport",
            null,
            ""
          ),
          // getItem(
          //   <NavLink to="/stemiolympiadreport">
          //     {" "}
          //     STEMI Olympiad{" "}
          //   </NavLink>,
          //   "STEMIOlympiadReport",
          //   <ProfileOutlined
          //     style={{
          //       fontSize: "25px",
          //       color: "#000",
          //       marginLeft: "0px",
          //     }}
          //   />,
          //   null,
          //   ""
          // ),

          getItem("STEMI Olympiad", "sub2", null, [
            getItem(
              <NavLink to="/stemiolympiad/overview"> Overview</NavLink>,
              "STEMIOlympiadReport",
              null,
              ""
            ),
            getItem(
              <NavLink to="/stemiolympiad/sector"> Sector</NavLink>,
              "STEMIOlympiadSectorReport",
              null,
              ""
            ),
            getItem(
              <NavLink to="/stemiolympiad/competition"> Olympiad/Competition</NavLink>,
              "STEMIOlympiadCompetitionReport",
              null,
              ""
            ),
          ]), getItem(
            <NavLink to="/volunteer-scientist-report">Volunteer Scientist </NavLink>,
            "VolunteerScientistReport",
            null,
            ""
          ),
        ],
        null,
        "Group"
      ),
      // isAuthorizedRole(["ADMIN", "CORE", "DSI_OFFICIAL"]) && (
      //   getItem(<NavLink to="/funding"> Funding </NavLink>, 'Funding',
      //     <DollarOutlined style={{
      //       fontSize: "25px",
      //       color: "#FFF",
      //       marginLeft: "0px",
      //     }} />, null, ''
      //   )
      // ),
          ];
  };

  function getItem(label, key, icon, children, type) {
    return {
      key,
      icon,
      children,
      label,
      type,
    };
  }

  const menuItems = getMenuItems();
  const Logout = () => {
    logout();
  };
  const cancel = () => { };

  const items = [
    {
      label: <Link to="/changepassword">Update Password</Link>,
      key: "1",
      icon: <EyeOutlined />,
    },
    {
      label: <Link to="/profile">Manage Profile</Link>,
      key: "2",
      icon: <ProfileOutlined />,
    },
    {
      label: (
        <Popconfirm
          title="Are you sure you want to logout?"
          onConfirm={() => Logout()}
          onCancel={() => cancel()}
          okText="Yes"
          cancelText="No"
        >
          Logout
        </Popconfirm>
        // <Link to="/" onClick={Logout}>Logout</Link>
      ),
      key: "3",
      icon: <LogoutOutlined />,
    },
  ];

  const menuOptions = {
    items,
    tooltip: true,
    onClick: handleMenuClick,
  };

  return (
    <>
      <RenderAuthenticated>
        <Layout
          className="site-layout" 
          style={{
            marginLeft: 200,
            backgroundColor: "#f0f2f5"
          }}
        >
          <Sider
            style={{
              overflow: "auto",
              height: "100vh",
              position: "fixed",
              left: 0,
              top: 0,
              bottom: 0,
              backgroundColor: "#0b4a7c0"
            }}
            breakpoint="lg"
            collapsedWidth="45px"
            width="220px"
            onBreakpoint={(broken) => { }}
            onCollapse={(collapsed, type) => { }}
          >
            <Menu
              className="side-menu"
              style={{
                marginTop: "35px",
              }}
              mode="vertical"
              items={menuItems}
            />
          </Sider>
          <Layout>
            <Header
              style={{
                position: "sticky",
                top: 0,
                zIndex: 10,
                width: "100%",
              }}
            >
              <div>
                <Row>
                  <Col xs={8} sm={8} md={8}>
                    <div>
                      <img
                        className="dst-logo"
                        src={require("../assets/DSTI-logo.png")}
                      />
                    </div>
                  </Col>
                  <Col className="center-align" xs={8} sm={8} md={8}>
                    <div>
                      <img
                        className="seims-logo"
                        src={require("../assets/seims-logo.png")}
                      />
                    </div>
                  </Col>

                  <Col xs={8} sm={8} md={8} className="admin-container ">
                    <RenderAnonymous>
                      <Button onClick={handleLogin}>Login</Button>
                    </RenderAnonymous>
                    <RenderAuthenticated>
                      <Dropdown menu={menuOptions}>
                        <Space>
                          <Button>
                            {userData?.firstName}
                            <UserOutlined />
                          </Button>
                        </Space>
                      </Dropdown>
                    </RenderAuthenticated>
                  </Col>
                </Row>
              </div>
              <div />
            </Header>

            <Content style={{ margin: "0 16px", backgroundColor: "#f0f2f5" }}>
              <div className="content-container">
                <TimerControl />
                <AppRouter />
              </div>
            </Content>
            <Footer style={{ textAlign: "center" }}>
              <Row>
                <Col  xs={8} sm={8} md={5} style={{ textAlign: "left" }}>
                  <Image preview={false} className="saasta-logo" src={require("../assets/saasta-logo.png")} />
                </Col>
                <Col  xs={8} sm={8} md={15} className="center-align">
                  <p className="footer-text">SEIMS ©{currentYear} CSIR</p>
                </Col>
                <Col  xs={8} sm={8} md={4} className="right-align">
                  <div>
                    <Image preview={false} className="csir-logo" src={require("../assets/csir-logo.png")} />
                  </div>
                </Col>
              </Row>
            </Footer>
          </Layout>
        </Layout>
      </RenderAuthenticated>

      <RenderAnonymous>
        <div>
          <AppRouter />
        </div>
      </RenderAnonymous>
    </>
  );
};

export default CustomLayout;
